import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import BtnIcons from '../../../../api/images/btnIcons';
import {
  eventPartnerDetailsRequest,
  eventPartnerUpdateRequest
} from '../../../../redux/actions/event/eventPartnerActions';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import Notification from '../../../../components/Notification/Notification';
import BOTable from '../../../../components/Tables/BOTable';
import useSchemaPartnerDetails from '../../../../schema/table-schema/useSchemaPartnerDetails';

function partnerDetails(props) {
  // -- props --//
  const { accountNo } = props?.location?.state;

  const { schema } = useSchemaPartnerDetails();

  // -- component const --//
  const title = '파트너사 상세 정보';

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [info, setInfo] = useState();
  const [tBody, setTbody] = useState([]);
  const [partnerCode, setPartnerCode] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // -- func & handler --//
  const goBack = () => {
    window.history.back();
  };

  const fetchData = () => {
    setIsLoading(true);

    dispatch(
      eventPartnerDetailsRequest({
        accountNo: accountNo,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setInfo(data);
          // setTbody(data?.list);

          // 인덱스를 추가하여 새로운 배열을 생성(중복 키 방지)
          const listWithIndex = data?.list.map((item, index) => ({
            index: index + 1, // 인덱스는 1부터 시작(번호 표기시 편의를 위해)
            ...item,
          }));

          setTbody(listWithIndex);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );
  }

  const updateInfo = (type)  => {
    let updatedInfo = { ...info };

    if (type === 'enabled') {
      updatedInfo.enabled = !updatedInfo.enabled;
      updatedInfo.invCode = '';
    } else if (type === 'invCode') {
      updatedInfo.invCode = partnerCode;
    }

    dispatch(
      eventPartnerUpdateRequest({
        partnerAccountNo: accountNo,
        invCode: updatedInfo.invCode,
        enabled: updatedInfo.enabled,
        callback: (data) => {
          console.log('요청 결괴: ', data);

          setNotificationMessage('업데이트 성공');
          setShowNotification(true);

          fetchData();
        },
        error: (e) => {
          console.log(e);

          setNotificationMessage(e.toString());
          setShowNotification(true);
        },
      })
    )
  }

  // -- react hooks --//
  useEffect(() => {

    fetchData();
  }, [accountNo]);

  // -- render --//
  return (
    <div className='page'>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="topSectionBack">
        <img
          src={BtnIcons.backIcon}
          className="backIcon"
          onClick={goBack}
          alt="goBack"
        />
        <p className="titleText">{title}</p>
      </div>

      <div className="spaceDiv10"/>

      <div className="contentsArea">
        <div className="basicInfoArea">

          <div className="spaceDiv10"/>

          <div className="rowDiv">
            <div className="leftDiv">파트너사 계정 정보</div>
            <div className="rightDiv col">{`${info?.email}(${accountNo})`}</div>
          </div>

          <div className="spaceDiv10"/>

          <div className="rowDiv">
            <div className="leftDiv">활성화 상태</div>
            <div className="rightDiv">
              {info?.enabled ? '활성' : '비활성'}
              <p
                onClick={() => updateInfo('enabled')}
                style={{
                  cursor: 'pointer',
                  color: info?.enabled ? '#E90A32' : '#0A7EE9',
                }}
              >
                {info?.enabled ? '비활성' : '활성'}
              </p>
            </div>
          </div>

          <div className="spaceDiv10"/>

          <div className="rowDiv">
            <div className="leftDiv">추천 코드</div>
            <div className="rightDiv">
              {`${info?.invCode} → `}

              <input
                value={partnerCode}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  const isKoreanInput = /[ㄱ-ㅎ|ㅏ-ㅣ가-힣]/.test(inputValue);

                  if (isKoreanInput) {
                    setShowNotification(true);
                    setNotificationMessage('코드에 한글 사용 불가.');
                    return false;
                  }

                  setPartnerCode(inputValue.toUpperCase().trim());
                }}
                placeholder={'20자 이하 영어 및 숫자'}
                maxLength={20}
                style={{ width: 'fit-content' }}
              />

              <button
                className='defaultBtn'
                onClick={() => updateInfo('invCode')}>
                업데이트
              </button>
            </div>
          </div>

          <div className="spaceDiv10"/>

          <div className="rowDiv">
            <div className="leftDiv">등록 일시</div>
            <div className="rightDiv col">{timeFormAPI.changeDataLog(info?.createdAt)}</div>
          </div>

          <div className="spaceDiv10"/>

          <div className="rowDiv">
            <div className="leftDiv">NFT 구입 기록</div>
            <div className="rightDiv col">
              <BOTable
                className={'partnerDetailsTable'}
                schema={schema}
                rows={tBody}
                loading={isLoading}
                // onClick={handleClickRow}
              />
            </div>
          </div>

        </div>

        <div className="spaceDiv10"/>

      </div>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}

    </div>
  );
}

export default partnerDetails;
